import { createFileRoute } from "@tanstack/react-router";
import { SeoPage } from "@/components/SeoPage";
import { faqJsonLd } from "@/lib/seo-jsonld";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { SOURCE_FOHM_VAGLEDNING, SOURCE_ALKOHOLLAGEN, SOURCE_PROP_2025_26, LAST_REVIEWED } from "@/lib/official-sources";

const faqs = [
  { q: "Vilka krav ställs på en restaurang efter 1 juni 2026?", a: "Restaurangen ska ha lämplig lokal och uppfylla kraven på personlig och ekonomisk lämplighet. Matservering är från 1 juni 2026 inte längre ett tillståndsvillkor. Tidigare krav på eget kök och varierat utbud av lagad mat slopades 1 juni 2026." },
  { q: "Behövs godkänt kunskapsprov?", a: "Ja. Minst en person med betydande inflytande (PBI) i verksamheten måste klara kommunens kunskapsprov i alkohollagen." },
  { q: "Hur lång är handläggningstiden?", a: "Räkna med 8–12 veckor från komplett ansökan till beslut." },
];

export const Route = createFileRoute("/serveringstillstand-restaurang")({
  component: () => (
    <SeoPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Guider", to: "/serveringstillstand-och-kunskapsprov" },
        { label: "För restaurang" },
      ]}
      title="Serveringstillstånd för restaurang"
      intro="Allt du behöver veta om att ansöka om serveringstillstånd för restaurang – krav på lokal, mat, lämplighet och kunskapsprov. Uppdaterat för de nya reglerna från 1 juni 2026."
      lastReviewed={LAST_REVIEWED}
      sources={[SOURCE_FOHM_VAGLEDNING, SOURCE_ALKOHOLLAGEN, SOURCE_PROP_2025_26]}
      sections={[
        { h2: "Krav på restaurangen (nya regler 2026)", body: "Från 1 juni 2026 är kravet på eget kök och varierat utbud av lagad mat borttaget. Matservering är inte längre ett villkor för tillståndet – kommunen får inte ställa krav på meny, kök eller matutbud vid prövningen. Restauranger som vill servera mat fortsätter självklart göra det." },
        { h2: "Lokal och ordning", body: "Lokalen ska vara brandgodkänd, ha bra överblick och möjliggöra ordning och nykterhet. Kommunen bedömer även läge och risk för störningar i närområdet." },
        { h2: "Kunskapsprovet", body: "Minst en PBI ska klara kommunens skriftliga kunskapsprov i alkohollagen. Med Alkoholprovet kan ni öva i samma format – 800 frågor och provsimulering." },
        { h2: "Så lyckas du", body: "Lämna in komplett ansökan, ha rutiner för ålderskontroll, kassa och bokföring redo, och förbered PBI:s noga inför kunskapsprovet. Läs mer i vår sammanfattning av de nya reglerna 2026." },
      ]}
      faqs={faqs}
      related={{
        title: "Relaterade sidor",
        links: [
          { to: "/serveringstillstand-och-kunskapsprov", label: "Hub – alla guider" },
          { to: "/nya-regler-serveringstillstand-2026", label: "Nya regler 2026" },
          { to: "/serveringstillstand-bar", label: "För bar & nattklubb" },
          { to: "/serveringstillstand-cafe", label: "För café" },
          { to: "/serveringstillstand-catering", label: "För catering" },
          { to: "/serveringstillstand-food-truck", label: "För food truck" },
          { to: "/serveringstillstand-stockholm", label: "Serveringstillstånd Stockholm" },
          { to: "/serveringstillstand-goteborg", label: "Serveringstillstånd Göteborg" },
          { to: "/serveringstillstand-malmo", label: "Serveringstillstånd Malmö" },
          { to: "/kunskapsprov-alkohollagen", label: "Kunskapsprov i alkohollagen" },
          { to: "/foretag", label: "Företagslösning" },
        ],
      }}
    />
  ),
  head: () => ({
    meta: [
      { title: "Serveringstillstånd för restaurang – krav & ansökan" },
      { name: "description", content: "Serveringstillstånd för restaurang: nya regler från 1 juni 2026 – kraven på eget kök och varierat matutbud är borttagna. Lokal, lämplighet, kunskapsprov och handläggningstid." },
      { property: "og:title", content: "Serveringstillstånd för restaurang" },
      { property: "og:description", content: "Krav, ansökan och kunskapsprov för restaurang." },
      { property: "og:url", content: "https://alkoholprovet.se/serveringstillstand-restaurang" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/serveringstillstand-restaurang" }],
    scripts: [
      faqJsonLd(faqs),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Guider", url: "https://alkoholprovet.se/serveringstillstand-och-kunskapsprov" },
        { label: "För restaurang", url: "https://alkoholprovet.se/serveringstillstand-restaurang" },
      ]),
    ],
  }),
});
